export function makeNameQuery(
  nameQuery: string,
  nestedPath: string[] = []
): any {
  const trimmedQuery = nameQuery.trim();
  const splittedQuery = trimmedQuery.split(" ").filter((v) => !!v);

  if (splittedQuery.length == 1) {
    return makeQuery(trimmedQuery, nestedPath);
  } else {
    const parts = splittedQuery.map((part: any) => {
      return makeQuery(part, nestedPath);
    });
    return {
      _and: parts,
    };
  }
}
export function makeNameQuery1(
  nameQuery: string,
  nestedPath: string[] = []
): any {
  const trimmedQuery = nameQuery.trim();
  const splittedQuery = trimmedQuery?.split(" ")?.filter((v) => !!v);
  if (splittedQuery.length == 1) {
    return [makeQuery(trimmedQuery, nestedPath)];
  } else {
    const parts = splittedQuery.map((part: any) => {
      return makeQuery(part, nestedPath);
    });
    return parts;
  }
}
function userNameQuery(queryStr: string, nestedPath: string[] = []): any {
  return wrap({ given_name: { _ilike: `%${queryStr}%` } }, [...nestedPath]);
}
function userFamilyNameQuery(queryStr: string, nestedPath: string[] = []): any {
  return wrap({ family_name: { _ilike: `%${queryStr}%` } }, [...nestedPath]);
}

function makeQuery(query: string, nestedPath = []): any {
  return {
    _or: [
      userNameQuery(query, nestedPath),
      userFamilyNameQuery(query, nestedPath),
    ],
  };
}

function wrap(value: Object, nestedPath: string[]): any {
  return nestedPath.reverse().reduce((value, curContainer) => {
    if (curContainer) return { [curContainer]: value };
    else return value;
  }, value);
}
